import React from 'react';
import { ChevronRight } from 'lucide-react';
import { expertises } from '../data/mock';

const Expertise = () => {
  return (
    <section className="py-10 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-6">
          <h2 className="text-2xl font-serif text-gray-800">
            Nos expertises
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3">
          {expertises.map((expertise) => (
            <a 
              key={expertise.id}
              href={expertise.href}
              className="flex items-center justify-between py-3 px-4 bg-white rounded-lg shadow-sm hover:shadow-md hover:bg-gray-50 transition-all group"
            >
              <span className="text-gray-800 group-hover:text-[#E30022] transition-colors font-medium text-sm">
                {expertise.title}
              </span>
              <ChevronRight className="h-4 w-4 text-gray-400 group-hover:text-[#E30022] group-hover:translate-x-1 transition-all flex-shrink-0 ml-2" />
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Expertise;
